import { useEffect } from 'react';
import { useLocalStorageState } from '@fuxi/eevee-hooks';
import { ACTIVITY_CENTER_FROM_LOGIN_FLAG } from '@yaotai/common-utils';

export function useActivityCenterFromLoginCheck() {
  const [fromLogin, setFromLogin] = useLocalStorageState<string | undefined>(ACTIVITY_CENTER_FROM_LOGIN_FLAG);

  useEffect(() => {
    return () => {
      fromLogin && setFromLogin(undefined);
    };
  }, [fromLogin, setFromLogin]);
}
